import { environment } from '@env/environment.uat';
import { L10nTranslationService } from 'angular-l10n';
import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

const COSTAR_SOURCE = 'CoStar';

@Component({
  selector: 'miq-costar-link-renderer',
  template: `
    <a
      *ngIf="isCostar"
      [href]="url"
      target="_blank"
      [title]="tooltip"
      style="text-decoration: underline; color: inherit;"
      >{{ value }}</a
    >
    <span *ngIf="!isCostar">{{ value }}</span>
  `,
  standalone: false,
})
export class MiqCostarLinkRendererComponent implements ICellRendererAngularComp {
  params: any;
  value: string;
  url: string;
  tooltip: string;
  isCostar: boolean;

  constructor(private translationService: L10nTranslationService) {}

  agInit(params: any): void {
    this.params = params;
    this.setValues(params);
  }

  refresh(params: any): boolean {
    this.params = params;
    this.setValues(params);
    return true;
  }

  private setValues(params: any) {
    const source = params.data?.external_property_id_source_desc;
    const id = params.data?.external_property_id;
    this.isCostar = source && source.toString().trim().toLowerCase() === COSTAR_SOURCE.toLowerCase() && !!id;
    this.value = params.value != null ? params.value : '';

    if (this.isCostar) {
      this.url = `${environment.COSTAR_BASE_URL}/${id}/lease`;
      this.tooltip = this.translationService.translate('recordsSearch.miqCostarProperty');
    }
  }
}
